import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Storage } from 'src/app/models/storage';
import { StorageService } from 'src/app/services/storage.service';
import _ from 'lodash';
import { MatDialog } from '@angular/material';
import { YourSavingsComponent } from '../your-savings/your-savings.component';
import { CONTAINERS } from '../../data/containers';
import { PrintService } from 'src/app/services/print.service';

@Component({
  selector: 'app-total-consumption',
  templateUrl: './total-consumption.component.html',
})
export class TotalConsumptionComponent implements OnInit {
  subscription: Subscription;
  storage: Storage;
  insideLiquidFoilConsumption = 0;
  outsideLiquidFoilConsumption = 0;
  flexConsumption = 0;

  readonly CONTAINERS = CONTAINERS;

  bucket = 2.4;
  sausage = 0.6; // opakowanie potocznie nazywane "kiełbasą"
  tin = 0.75;
  tape = 1;

  insideLiquidFoilConsumptionBucketCount = 0;
  insideLiquidFoilConsumptionSausageCount = 0;

  outsideLiquidFoilConsumptionBucketCount = 0;
  outsideLiquidFoilConsumptionSausageCount = 0;

  flexConsumptionTin = 0;
  outsideWindowLength = 0;
  tapeConsumption = 0;

  containersPlural = {
    insideBucket: 'wiadro',
    insideSausage: 'kiełbasa',
    outsideBucket: 'wiadro',
    outsideSausage: 'kiełbasa',
    tape: 'taśma',
    tin: 'puszka'

  };
  constructor(
    private storageService: StorageService,
    public dialog: MatDialog,
    private printService: PrintService
  ) { }

  ngOnInit() {
    this.storage = this.storageService.storage;
    const container = this.getContainerBySystemId(this.storage.systemType);

    if (container) {
      this.bucket = container.usage.bucket;
      this.sausage = container.usage.sausage;
      this.tin = container.usage.tin;
      this.tape = container.usage.tape;
    }
    this.storageSubscription();
  }

  private storageSubscription() {
    this.subscription = this.storageService.storage$.subscribe(async (data) => {
      this.storage = data;

      this.countConsumption();
      this.countBoxes();
    });
  }

  private countConsumption() {
    this.insideLiquidFoilConsumption = 0;
    this.outsideLiquidFoilConsumption = 0;
    this.flexConsumption = 0;
    this.outsideWindowLength = 0;

    _.forEach(this.storage.windows, window => {
      if (window.type === 'STANDARD') {
        const isSameDepth = window.standard.isSameDepth;
        const windowDepth = window.standard.depth;

        _.forEach(window.standard.inside.edges, edge => {
          const depth = isSameDepth ? windowDepth : edge.depth;

          this.insideLiquidFoilConsumption += 2 * ((10 + edge.width) / 1000) * edge.length / 1000;
          this.flexConsumption += ((edge.width) / 100) * ((depth) / 100) * edge.length / 100;
        });

        _.forEach(window.standard.outside.edges, edge => {
          const depth = isSameDepth ? windowDepth : edge.depth;
          this.outsideWindowLength += edge.length / 1000;
          this.outsideLiquidFoilConsumption += 1 * ((10 + edge.width) / 1000) * edge.length / 1000;
        });


      } else if (window.type === 'NONSTANDARD') {

        _.forEach(window.nonstandard.inside.edges, edge => {
          this.insideLiquidFoilConsumption += 2 * ((10 + edge.width) / 1000) * edge.length / 1000;
          this.flexConsumption += ((edge.width) / 100) * ((edge.depth) / 100) * edge.length / 100;
        });

        _.forEach(window.nonstandard.outside.edges, edge => {
          this.outsideWindowLength += edge.length / 1000;
          this.outsideLiquidFoilConsumption += 1 * ((10 + edge.width) / 1000) * edge.length / 1000;
        });

      }
      // mnozy wyniki razy ilosc okien
      this.insideLiquidFoilConsumption *= window.amount;
      this.flexConsumption *= window.amount;
      this.outsideLiquidFoilConsumption *= window.amount;
      this.outsideWindowLength *= window.amount;
    });

  }

  private countBoxes() {
    this.insideLiquidFoilConsumptionBucketCount = Math.ceil(this.insideLiquidFoilConsumption / this.bucket);

    this.insideLiquidFoilConsumptionSausageCount = Math.ceil(this.insideLiquidFoilConsumption / this.sausage);

    this.outsideLiquidFoilConsumptionBucketCount = Math.ceil(this.outsideLiquidFoilConsumption / this.bucket);

    this.outsideLiquidFoilConsumptionSausageCount = Math.ceil(this.outsideLiquidFoilConsumption / this.sausage);

    this.flexConsumptionTin = Math.ceil(this.flexConsumption / this.tin);
    this.tapeConsumption = Math.ceil(this.outsideWindowLength / this.tape);
    this.getContainersPlural();
  }

  private getContainersPlural(): void {
    this.containersPlural.insideBucket = this.getPluralsBuckets(this.insideLiquidFoilConsumptionBucketCount);
    this.containersPlural.insideSausage = this.getPluralsSausages(this.insideLiquidFoilConsumptionSausageCount);
    this.containersPlural.outsideBucket = this.getPluralsBuckets(this.outsideLiquidFoilConsumptionBucketCount);
    this.containersPlural.outsideSausage = this.getPluralsSausages(this.outsideLiquidFoilConsumptionSausageCount);
    this.containersPlural.tin = this.getPluralsTins(this.flexConsumptionTin);
    this.containersPlural.tape = this.getPluralsTapes(this.tapeConsumption);
  }

  private getContainerBySystemId(id) {
    for (const container of CONTAINERS) {
      if (container.sys_id === id) {
        return container;
      }
    }
    return null;
  }

  openModal(type) {
    switch (type) {
      case 'YOUR SAVINGS':
        const dialogRef = this.dialog.open(YourSavingsComponent, {
          width: '980px',
          panelClass: 'selena-calculator-dialog',
          data: {
            type: 'YOUR_SAVINGS'
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          if (result === 'OK') {
            this.storageService.clearStorage();
          }
        });
        break;
    }
  }

  getPluralsBuckets(buckets) {
    if (buckets === 1) {
      return 'wiadro';
    } else if (
      buckets % 10 === 2 && buckets % 100 !== 12 ||
      buckets % 10 === 3 && buckets % 100 !== 13 ||
      buckets % 10 === 4 && buckets % 100 !== 14) {
      return 'wiadra';
    } else {
      return 'wiader';
    }
  }

  getPluralsSausages(sausages) {
    if (sausages === 1) {
      return 'kiełbasę';
    } else if (
      sausages % 10 === 2 && sausages % 100 !== 12 ||
      sausages % 10 === 3 && sausages % 100 !== 13 ||
      sausages % 10 === 4 && sausages % 100 !== 14) {
      return 'kiełbasy';
    } else {
      return 'kiełbas';
    }
  }

  getPluralsTins(tins) {
    if (tins === 1) {
      return 'puszkę';
    } else if (
      tins % 10 === 2 && tins % 100 !== 12 ||
      tins % 10 === 3 && tins % 100 !== 13 ||
      tins % 10 === 4 && tins % 100 !== 14) {
      return 'puszki';
    } else {
      return 'puszek';
    }
  }

  getPluralsTapes(tapes) {
    if (tapes === 1) {
      return 'paczkę';
    } else if (
      tapes % 10 === 2 && tapes % 100 !== 12 ||
      tapes % 10 === 3 && tapes % 100 !== 13 ||
      tapes % 10 === 4 && tapes % 100 !== 14) {
      return 'paczki';
    } else {
      return 'paczek';
    }
  }

  createReport() {
    // this.printService.print(this.storage);
    this.printService.print(this.storage);
    // printPromise.then(()=>{
    // })
  }
}
